import { create } from "../../../../../common/utils/zustand_state_manager";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";
import { EmpreendimentoDropDown } from "../../../domain/models/empreendimento";

/**
 * useObrasListaFilter
 */

type State = {
  tipoPesquisa: number;
  valueField: string | null;
  statusDocumentos: number;
  resistenciaCompressao: number;
  statusEquipamentos: number;
  statusObras: number;
  centroCustosDropdown: CentroCustoDropDown[] | undefined;
  empreendimentosDropdown: EmpreendimentoDropDown[] | undefined;
};

type Actions = {
  clearFilters: () => void;
};

export const initialObrasListaFilter: Partial<State> = {
  tipoPesquisa: 1,
  valueField: null,
  statusDocumentos: 0,
  resistenciaCompressao: 0,
  statusEquipamentos: 0,
  statusObras: 0,
};

export const useObrasListaFilter = create<State & Actions>((set) => ({
  tipoPesquisa: 1,
  valueField: null,
  statusDocumentos: 0,
  resistenciaCompressao: 0,
  statusEquipamentos: 0,
  statusObras: 0,
  centroCustosDropdown: undefined,
  empreendimentosDropdown: undefined,
  clearFilters: () => set({
    ...initialObrasListaFilter,
  }),
}));